module.exports = __webpack_public_path__ + "img/crm_sales3.e4e75135.png";